import React from 'react'

import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'

import { useValidationErrorEntity } from 'src/hooks/useEntity'
import { GENERIC_ERROR_KEY } from 'src/models/dto/TemplateValidationError'

export const ItemEditorValidationErrors = ({
    dataTestId,
    showValidationError = false,
    itemId,
}: {
    dataTestId?: string
    showValidationError?: boolean
    itemId: string
}) => {
    const { entity: validationErrorEntity } = useValidationErrorEntity(itemId)
    if (!(validationErrorEntity.validationErrors[GENERIC_ERROR_KEY] && showValidationError)) {
        return null
    }

    return (
        <MessageBanner dataTestId={dataTestId} type={MessageBannerType.Error}>
            <ul>
                {validationErrorEntity.validationErrors[GENERIC_ERROR_KEY].map((message, index) => (
                    <li key={index}>{message}</li>
                ))}
            </ul>
        </MessageBanner>
    )
}
